/** Logo Officina Tool Control: simbolo razzo (default) o lockup completo con la scritta. */
export function BrandLogo({ size = 36, full = false, className = "" }) {
  const file = full ? "logo-officina.png" : "logo-officina-mark.png";
  return (
    <img
      className={`brand-logo-img ${className}`.trim()}
      src={`${process.env.PUBLIC_URL || ""}/${file}?v=2`}
      alt="Officina Tool Control"
      style={full ? { height: size } : { width: size, height: size }}
      data-testid="brand-logo"
    />
  );
}
